import {Col, Drawer, Input, Row, Tabs, Tooltip} from "antd";
import React, {useCallback, useEffect, useRef} from "react";
import { ChatDrawerWrapper } from "./ChatDrawer.style";
import SendIcon from "@iso/assets/images/icon/send.svg";
import {useDispatch, useSelector} from "react-redux";
import { detectMob } from '@utils/responsiveClsx';
import TimesIcon from '@iso/assets/images/icon/opportunity/times.svg';
import {
  FETCH_CONVERSATIONS, REFETCH_MESSAGE,
  RESET_CONVERSATIONS,
  SET_CONVERSATION_TYPE,
  SET_CONVERSATIONS_LOADING
} from "@iso/redux/chat/actions";
import ChatDrawerSideBar from "@iso/components/ChatDrawer/ChatDrawerSideBar";
import ChatDrawerHeader from "@iso/components/ChatDrawer/ChatDrawerHeader";
import ChatDrawerDetail from "@iso/components/ChatDrawer/ChatDrawerDetail";
import {postMessage} from "@api/chat";
import actions from "@iso/redux/user/actions";

const MESSAGE_MAX_LENGTH = 10000;
export const CONVERSATION_ACTIVE_STATUS = 'active';

export const CHAT_GROUP = {
  HIRING: 'hiringConv',
  WORKING: 'workingConv',
  DIRECT: 'directConv'
}

const ChatDrawer = ({ visible, onClose }) => {
  const dispatch = useDispatch();
  const { recordPerPage, selected, type } = useSelector((state) => state.chat);
  const [message, setMessage] = React.useState("");
  const [isShowConventions, setIsShowConversations] = React.useState(true);
  const [hasInputError, setHasInputError] = React.useState(false);
  const chatBoxRef = useRef();
  const handleShowConversations = () => {
    setIsShowConversations(!isShowConventions);
  }
  const tabItems = [
    {
      key: CHAT_GROUP.HIRING,
      label: <span className='pl-4 pr-4'>Hiring</span>,
      children: <ChatDrawerSideBar onClickConversation={handleShowConversations} />
    },
    {
      key: CHAT_GROUP.WORKING,
      label: <span className='pl-4 pr-4'>Working</span>,
      children: <ChatDrawerSideBar onClickConversation={handleShowConversations}/>
    },
    {
      key: CHAT_GROUP.DIRECT,
      label: <span className='pl-4 pr-4'>People</span>,
      children: <ChatDrawerSideBar onClickConversation={handleShowConversations}/>
    },
  ];
  useEffect(() => {
    dispatch({
      type: actions.GET_USER_PROFILE
    })
  }, [dispatch])

  useEffect(() => {
    dispatch({
      type: SET_CONVERSATIONS_LOADING,
      payload: true
    })
    dispatch({
      type: FETCH_CONVERSATIONS,
      payload: {
        page: 1,
        recordPerPage,
        convType: type
      }
    })
  }, [dispatch, recordPerPage, type])

  const handleChat = useCallback((e) => {
    if (e.shiftKey && e.key === 'Enter') return;
    if (e.key === 'Enter') e.preventDefault();
    if (hasInputError) return;

    if (message) {
      postMessage({
        conversationId: selected._id,
        content: message
      }).then(res => {
        dispatch({
          type: REFETCH_MESSAGE
        })
      })
      setTimeout(() => {
        setMessage("")
      }, 100);
    }
  });

  const handleChangeType = useCallback((type) => {
    dispatch({
      type: RESET_CONVERSATIONS
    })
    dispatch({
      type: SET_CONVERSATION_TYPE,
      payload: type
    })
  }, [dispatch])

  const handleChangeMessage = useCallback((e) => {
    if (e.target.value.length > MESSAGE_MAX_LENGTH && !hasInputError) setHasInputError(true)
    if (e.target.value.length <= MESSAGE_MAX_LENGTH && hasInputError) setHasInputError(false)

    setMessage(e.target.value)
  })

  const renderContentTab = useCallback(()=> (
    <Tabs items={tabItems} tabBarStyle={{ paddingLeft: '1.25em' }} activeKey={type} onChange={(type) => handleChangeType(type)} />
  ), [handleChangeType, tabItems, type])

  const renderContentChat = useCallback((span = 9)=> (
    <Col span={span} className="h-full">
      <div className="chat-list">
        <div className='flex items-center w-full justify-between'>  
          <strong className=" text-24 block mb-15 font-bold pl-4 pt-5">Chat</strong>
          {
            detectMob() && <div>
              <button
                className='app-button button-outline'
                style={{
                  backgroundColor: '#F9F9F9',
                }}
                onClick={() => setIsShowConversations(!isShowConventions)}>
                  <span className='text-11'>Conversation</span>
              </button>
              <img src={TimesIcon} alt='close' className='ml-20 mr-15 cursor-pointer' onClick={onClose} />
            </div>
          }
          
        </div>
        {(detectMob() && !isShowConventions) ?<></> : renderContentTab()}
      </div>
    </Col>
  ), [isShowConventions, onClose, renderContentTab])

  const renderContentConversation = useCallback((span = 15)=> (
    <Col span={span} className="h-full">
    <div className='flex flex-col'>
    {selected && (
      <>
        <ChatDrawerHeader onClose={onClose}/>
        <ChatDrawerDetail ref={chatBoxRef} />
        <div className="flex border-t-2 chat-action">
          {
            selected?.status === CONVERSATION_ACTIVE_STATUS && (
              <>
                <Input.TextArea
                  rows={2}
                  autoSize={{ minRows: 1, maxRows: 4 }}
                  className="chat-input scrollbar-hide"
                  placeholder="Type your message here..."
                  value={message}
                  onChange={handleChangeMessage}
                  onPressEnter={(e) => handleChat(e)}
                />
                <div onClick={handleChat} className="send-icon">
                  <img src={SendIcon} alt="send" />
                </div>
              </>
            )
          }

        </div>
      </>
    )}
    <Tooltip
      title='Maximum of 10.000 characters allowed'
      color={'#f14a4e'}
      open={hasInputError}
      destroyTooltipOnHide={true}
      placement={'bottomRight'}
    />
    </div>
  </Col>
  ), [handleChangeMessage, handleChat, hasInputError, message, onClose, selected])

  return (
    <Drawer
      contentWrapperStyle={{ height:  detectMob() ? '100%' : '758px' }}
      width={detectMob() ? '100%' : 869}
      className="chat-drawer"
      open={visible}
      onClose={onClose}
      closable={false}
      destroyOnClose={true}
    >
      <ChatDrawerWrapper>
        {detectMob() ? 
          <Col span={24}>
            {renderContentChat(24)}
            {renderContentConversation(24)}
          </Col> : 
          <Row className="chat-box h-full">
            {renderContentChat()}
            {renderContentConversation()}
          </Row>
        }
      </ChatDrawerWrapper>
    </Drawer>
  );
};

export default ChatDrawer;
